import React from 'react';
import { Empty } from 'antd';

/**
 * EmptyState — 空状態
 * ------------------------------------------------------------------
 * antd Empty を薄くラップした共通の空状態表示。ドメインに即した
 * メッセージを props で受け取り、余白・色を tokens.css に統一する（Ph.3）。
 *
 * 設計方針:
 *   - antd Empty の API を踏襲（image / imageStyle 等は素通し）。
 *   - description の代わりに message を主 props 名にし、補助 children に
 *     アクション（再読込ボタン等）を置けるようにする。
 *   - 余白・色は tokens.css の CSS 変数のみ使用（HEX 禁止）。
 *
 * @param {object}      props
 * @param {React.ReactNode} [props.message='データがありません'] 空状態の説明文（ドメイン文言）
 * @param {React.ReactNode} [props.children]          補助アクション（ボタン等。説明文の下に表示）
 * @param {React.ReactNode} [props.image]             antd Empty の image（既定 / PRESENTED_IMAGE_SIMPLE 等）
 * @param {React.CSSProperties} [props.style]         追加スタイル（マージされる）
 *  ...rest                                           その他 antd Empty props を素通し
 *
 * @example
 * <EmptyState message="応答者がいません" />
 * <EmptyState message="調査結果がありません">
 *   <Button onClick={reload}>再読み込み</Button>
 * </EmptyState>
 */
const EmptyState = ({
  message = 'データがありません',
  children,
  style,
  ...rest
}) => {
  const mergedStyle = {
    padding: 'var(--space-8) var(--space-4)',
    color: 'var(--grey-65)',
    ...style,
  };

  return (
    <Empty description={message} style={mergedStyle} {...rest}>
      {children}
    </Empty>
  );
};

export default EmptyState;
